import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as authActions from '../actions/orders.action';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { OrdersService } from 'src/app/shop/services';
import { getCustomerAccessToken, getOrdersPageInfo } from '../selectors';
import { getActiveLanguageNoCulture } from '@teamfoster/sdk/language-ngrx';

@Injectable()
export class OrdersEffects {
  constructor(private actions$: Actions, private ordersService: OrdersService, private store: Store) {}

  GetOrders$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(authActions.LoadOrders),
      withLatestFrom(this.store.select(getCustomerAccessToken), this.store.select(getActiveLanguageNoCulture)),
      switchMap(([, token, lang]) =>
        this.ordersService.GetOrders(token?.accessToken ?? '', undefined, undefined, lang).pipe(
          map(orders => authActions.LoadOrdersSuccess({ orders })),
          catchError(errors => of(authActions.LoadOrdersFail({ errors })))
        )
      )
    );
  });

  LoadMoreOrders$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(authActions.LoadMoreOrders),
      withLatestFrom(
        this.store.select(getCustomerAccessToken),
        this.store.select(getOrdersPageInfo),
        this.store.select(getActiveLanguageNoCulture)
      ),
      switchMap(([{}, token, pageInfo, lang]) =>
        this.ordersService.GetOrders(token?.accessToken ?? '', pageInfo?.cursor, undefined, lang).pipe(
          map(orders => authActions.LoadOrdersSuccess({ orders })),
          catchError(errors => of(authActions.LoadOrdersFail({ errors })))
        )
      )
    );
  });
}
